












import Vue from 'vue';

import HeightCalculator from '@/components/HeightCalculator.vue';

export default Vue.extend({
  components: {
    HeightCalculator
  },

  props: {
    estimatedItemHeight: Number,
    items: Array,
    fillHeight: Boolean,
    minHeight: {
      type: Number,
      required: false,
      default: 600
    }
  },

  data() {
    return {
      height: 0,

      // The furthest we've gotten down the list (in pages)
      maxDepth: 3
    };
  },

  computed: {
    itemsPerPage(): number {
      return Math.ceil(this.height / this.estimatedItemHeight);
    },
    renderCount(): number {
      return this.maxDepth * this.itemsPerPage;
    },
    itemsToRender(): unknown[] {
      return this.items.slice(0, this.renderCount);
    }
  },

  methods: {
    handleScroll(event: Event) {
      const t: Element | null = event.target as Element | null;

      if (!t) {
        return;
      }

      const p = Math.floor(t.scrollTop / t.clientHeight);

      // +2 because if the top of the list is near the bottom of
      // page 1, it's also showing most of page 2.
      if (this.maxDepth < p + 3) {
        this.maxDepth = p + 3;
      }
    },

    onHeightChange({
      windowHeight,
      positionTop
    }: {
      windowHeight: number;
      positionTop: number;
    }) {
      this.height = Math.max(windowHeight - positionTop, this.minHeight);
    }
  },

  watch: {
    items(current, previous) {
      if (current.length != previous.length) {
        this.maxDepth = 3;
      }
    }
  }
});
